import {
  makeStyles,
  TableBody,
  TableCell,
  TableFooter,
  TableRow
} from "@material-ui/core";
import Checkbox from "@saleor/components/Checkbox";
import ResponsiveTable from "@saleor/components/ResponsiveTable";
import Skeleton from "@saleor/components/Skeleton";
import TableCellHeader from "@saleor/components/TableCellHeader";
import TableHead from "@saleor/components/TableHead";
import TablePagination from "@saleor/components/TablePagination";
import { ManagementCountryList_countries_edges_node } from "@saleor/countries/types/ManagementCountryList";
import { CountryListUrlSortField } from "@saleor/countries/urls";
import { translateBoolean } from "@saleor/intl";
import { renderCollection } from "@saleor/misc";
import { ListActions, ListProps, SortPage } from "@saleor/types";
import { getArrowDirection } from "@saleor/utils/sort";
import React from "react";
import { FormattedMessage, useIntl } from "react-intl";
export interface CountryListProps
  extends ListProps,
    ListActions,
    SortPage<CountryListUrlSortField> {
  country: ManagementCountryList_countries_edges_node[];
}

const numberOfColumns = 8;
const useStyles = makeStyles(
  theme => ({
    [theme.breakpoints.up("lg")]: {
      colName: {
        width: "auto",
        overflow: "hidden", // 超出的文本隐藏
        textOverflow: "ellipsis", // 溢出用省略号显示
        whiteSpace: "nowrap" // 溢出不换行
      }
    }
  }),
  { name: "CountryList" }
);
const CountryList: React.FC<CountryListProps> = ({
  country,
  disabled,
  isChecked,
  onNextPage,
  onPreviousPage,
  onRowClick,
  pageInfo,
  selected,
  sort,
  toggle,
  toggleAll,
  toolbar,
  settings,
  onUpdateListSettings,
  onSort
}) => {
  const classes = useStyles({});
  const intl = useIntl();
  return (
    <ResponsiveTable>
      <TableHead
        colSpan={numberOfColumns}
        selected={selected}
        disabled={disabled}
        items={country}
        toggleAll={toggleAll}
        toolbar={toolbar}
      >
        <TableCellHeader
          className={classes.colName}
          direction={
            sort.sort === CountryListUrlSortField.name
              ? getArrowDirection(sort.asc)
              : undefined
          }
          onClick={() => onSort(CountryListUrlSortField.name)}
        >
          <FormattedMessage defaultMessage="Name" />
        </TableCellHeader>
        <TableCellHeader
          className={classes.colName}
          direction={
            sort.sort === CountryListUrlSortField.isoTwoCode
              ? getArrowDirection(sort.asc)
              : undefined
          }
          onClick={() => onSort(CountryListUrlSortField.isoTwoCode)}
        >
          <FormattedMessage defaultMessage="IsoTwoCode" />
        </TableCellHeader>
        <TableCellHeader
          className={classes.colName}
          direction={
            sort.sort === CountryListUrlSortField.isoThreeCode
              ? getArrowDirection(sort.asc)
              : undefined
          }
          onClick={() => onSort(CountryListUrlSortField.isoThreeCode)}
        >
          <FormattedMessage defaultMessage="IsoThreeCode" />
        </TableCellHeader>
        <TableCellHeader
          className={classes.colName}
          direction={
            sort.sort === CountryListUrlSortField.isoNumberCode
              ? getArrowDirection(sort.asc)
              : undefined
          }
          onClick={() => onSort(CountryListUrlSortField.isoNumberCode)}
        >
          <FormattedMessage defaultMessage="IsoNumberCode" />
        </TableCellHeader>

        <TableCellHeader
          className={classes.colName}
          direction={
            sort.sort === CountryListUrlSortField.regionsCount
              ? getArrowDirection(sort.asc)
              : undefined
          }
          onClick={() => onSort(CountryListUrlSortField.regionsCount)}
        >
          <FormattedMessage defaultMessage="RegionsCount" />
        </TableCellHeader>
        <TableCellHeader
          className={classes.colName}
          direction={
            sort.sort === CountryListUrlSortField.displayOrder
              ? getArrowDirection(sort.asc)
              : undefined
          }
          onClick={() => onSort(CountryListUrlSortField.displayOrder)}
        >
          <FormattedMessage defaultMessage="DisplayOrder" />
        </TableCellHeader>
        <TableCellHeader>
          <FormattedMessage defaultMessage="Enabled" />
        </TableCellHeader>
      </TableHead>
      {/* <TableFooter>
                <TableRow>
                <TablePagination
                    colSpan={numberOfColumns}
                    hasNextPage={pageInfo && !disabled ? pageInfo.hasNextPage : false}
                    onNextPage={onNextPage}
                    hasPreviousPage={
                    pageInfo && !disabled ? pageInfo.hasPreviousPage : false
                    }
                    onPreviousPage={onPreviousPage}
                />
                </TableRow>
            </TableFooter> */}
      <TableFooter>
        <TableRow>
          <TablePagination
            colSpan={numberOfColumns}
            settings={settings}
            hasNextPage={pageInfo && !disabled ? pageInfo.hasNextPage : false}
            onNextPage={onNextPage}
            onUpdateListSettings={onUpdateListSettings}
            hasPreviousPage={
              pageInfo && !disabled ? pageInfo.hasPreviousPage : false
            }
            onPreviousPage={onPreviousPage}
          />
        </TableRow>
      </TableFooter>
      <TableBody>
        {renderCollection(
          country,
          acountry => {
            const isSelected = acountry ? isChecked(acountry.id) : false;
            return (
              <TableRow
                selected={isSelected}
                hover={!!acountry}
                key={acountry ? acountry.id : "skeleton"}
                onClick={acountry && onRowClick(acountry.id)}
              >
                <TableCell padding="checkbox">
                  <Checkbox
                    checked={isSelected}
                    disabled={disabled}
                    disableClickPropagation
                    onChange={() => toggle(acountry.id)}
                  />
                </TableCell>
                <TableCell className={classes.colName}>
                  {acountry ? (
                    <p
                      className={classes.colName}
                      style={{ width: "100%" }}
                      title={acountry.name}
                    >
                      {acountry.name}
                    </p>
                  ) : (
                    <Skeleton />
                  )}
                </TableCell>
                <TableCell className={classes.colName}>
                  {acountry ? (
                    <p
                      className={classes.colName}
                      style={{ width: "100%" }}
                      title={acountry.isoTwoCode}
                    >
                      {acountry.isoTwoCode}
                    </p>
                  ) : (
                    <Skeleton />
                  )}
                </TableCell>
                <TableCell className={classes.colName}>
                  {acountry ? (
                    <p
                      className={classes.colName}
                      style={{ width: "100%" }}
                      title={acountry.isoThreeCode}
                    >
                      {acountry.isoThreeCode}
                    </p>
                  ) : (
                    <Skeleton />
                  )}
                </TableCell>
                <TableCell className={classes.colName}>
                  {acountry ? (
                    <p
                      className={classes.colName}
                      style={{ width: "100%" }}
                      title={acountry.isoNumberCode}
                    >
                      {acountry.isoNumberCode}
                    </p>
                  ) : (
                    <Skeleton />
                  )}
                </TableCell>

                <TableCell className={classes.colName}>
                  {acountry ? (
                    <p
                      className={classes.colName}
                      style={{ width: "100%" }}
                      title={String(acountry.regionsCount)}
                    >
                      {acountry.regionsCount}
                    </p>
                  ) : (
                    <Skeleton />
                  )}
                </TableCell>
                <TableCell className={classes.colName}>
                  {acountry ? acountry.displayOrder : <Skeleton />}
                </TableCell>
                <TableCell className={classes.colName}>
                  {acountry ? (
                    translateBoolean(acountry.enable, intl)
                  ) : (
                    <Skeleton />
                  )}
                </TableCell>
              </TableRow>
            );
          },
          () => (
            <TableRow>
              <TableCell colSpan={numberOfColumns}>
                <FormattedMessage defaultMessage="No country found" />
              </TableCell>
            </TableRow>
          )
        )}
      </TableBody>
    </ResponsiveTable>
  );
};

export default CountryList;
